import { DateTime } from "luxon";
import { IEntitySimpleDTO } from "../@types/common";
import { IActRevaluationItemCreateDTO, IActRevaluationItemEditDTO, IActRevaluationItemGetDTO } from "./ActRevaluationItem";
import { IBaseDocumentGetDTO, IBaseDocumentViewDTO } from "./base";

////////////////////////////////////////////////////////////////////////////
export interface IActRevaluationViewDTO extends IBaseDocumentViewDTO, IDocumentCostInfoViewDTO {
    readonly storeName: string,
    readonly pricingModelName: string,
    readonly comment: string,
    readonly newBarcode: boolean,
    readonly priceBaseDocName: string,
    readonly revaluationReasonName: string,
    readonly countKizScan: number
}
////////////////////////////////////////////////////////////////////////////
export interface IActRevaluationGetDTO extends IBaseDocumentGetDTO, IDocumentCostInfoGetDTO {
    readonly store: IEntitySimpleDTO,
    readonly pricingModel: IEntitySimpleDTO,
    readonly dateModified: DateTime,
    readonly comment: string,
    readonly newBarcode: true,
    readonly priceBaseDoc: IEntitySimpleDTO,
    readonly revaluationReason: IEntitySimpleDTO
    readonly items: IActRevaluationItemGetDTO[],
}
////////////////////////////////////////////////////////////////////////////
export interface IActRevaluationCreateDTO {
    readonly idGlobal?: string,
    readonly documentDate: DateTime,
    readonly idStoreGlobal?: string,
    readonly idPricingModelGlobal: string,
    readonly mnemocode: string,
    readonly comment: string,
    readonly newBarcode: boolean,
    readonly idPriceBaseDocGlobal: string,
    readonly idActRevaluationReasonGlobal: string,
    readonly items: IActRevaluationItemCreateDTO[]
}
////////////////////////////////////////////////////////////////////////////
export interface IActRevaluationUpdateDTO extends IActRevaluationCreateDTO {
    readonly items: IActRevaluationItemEditDTO[]
}

export interface IActRevaluationFromStoreDTO {
    readonly idStoreGlobalList: string[]
    readonly revaluationTaxType: number,
    readonly hasRetailPrice: boolean
    readonly eventName: string
    readonly valueName: string
    readonly idPricingModel?: string
}

export interface IActRevaluationFillWithRemnantsOnStoreDto {
    readonly revaluationTaxType: number,
    readonly hasRetailPrice: boolean
    readonly eventName: string
    readonly valueName: string
    readonly calculateWithPricingModel: boolean,
    readonly idPricingModel: string | null,
    readonly generateNewBarcodes: boolean
}

export interface IActRevaluationValidateStoresDto {
    readonly idStoreGlobalList: string[]
}

export interface IActRevaluationValidateStoresResponse {
    readonly isSuccess: boolean
    readonly errorMessage: string
}

export interface IActRevaluationFromStoresResponse {
    readonly actsRevaluationCreatedNo: number,
    readonly infoMessages: string
}

export interface IActRevaluationFromSingleStoreResponse {
    readonly createdIds: string[]
    readonly infoMessages: string
}

export interface IActRevaluationFillWithRemnantsOnStoreResponse {
    readonly documentId: string
    readonly infoMessages: string
}

export enum ActRevaluationRemnantsType {
    VatSourceOnly = "VatSourceOnly",
    AllRemnants = "AllRemnants"
}
